import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { locale } from 'devextreme/localization';
import { LocalStorageKey } from './core/localstorage/service';
import enTranslation from "./localization/en.json"
import nlTranslation from "./localization/nl.json"

const resources = {
  en: { translation: enTranslation },
  nl: { translation: nlTranslation }
}

const languageDetector = new LanguageDetector(null, {
  order: ['localStorage', 'navigator', 'htmlTag'],
  caches: ['localStorage'],
  lookupLocalStorage: LocalStorageKey.LANGUAGE
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    debug: true,
  });

locale(i18n.language)

export default i18n;
